import type { ObjectValues } from "@/src/shared/types/objectValues";
import type { DSIconName } from "@/src/design_system/primitives/icon/types/iconName.generated";
import type { DSAriaLabelProps, DSDirectionProps, DSStatefulProps } from "@/src/design_system/shared/types/props";

export const DS_TABS_VARIANT = {
  Default: "default",
  OnlyTexts: "only-texts",
  OnlyIcons: "only-icons",
} as const;

export type DSTabsVariant = ObjectValues<typeof DS_TABS_VARIANT>;

export type DSTabsItem = Pick<DSStatefulProps, "disabled"> &
  Pick<DSAriaLabelProps, "ariaLabel"> & {
    value: string;
    tabId?: string;
    panelId?: string;
    label?: string;
    href?: string;
    icon?: DSIconName;
    badgeText?: string | number;
    /** Shows the design-system tooltip for variants that include visible text. */
    showTooltip?: boolean;
    /** Tooltip text. Defaults to label, then ariaLabel. */
    tooltipText?: string;
  };

export type DSTabProps = Pick<DSStatefulProps, "disabled"> &
  DSDirectionProps & {
    item: DSTabsItem;
    active?: boolean;
    variant?: DSTabsVariant;
    tabIndex?: number;
  };

export type DSTabsProps = Pick<DSStatefulProps, "disabled"> &
  DSDirectionProps &
  Pick<DSAriaLabelProps, "ariaLabel"> & {
    items: DSTabsItem[];
    modelValue?: string;
    variant?: DSTabsVariant;
  };
